<template lang="pug">
section(class="container pb-10")
    div(class="flex flex-col items-center w-full px-2 sm:p-0 sm:w-[400px] m-auto")
        h1 Enter Access Code
        baseForm(ref="loginForm" @submit="login" class="w-full lg:w-[300px]")
            template(#default="{ errors }")
                baseInput(
                    type='text',
                    label='Access Code',
                    name='accessCode',
                    :isRequired="true",
                    default-error-text='Please enter the correct code.',
                    v-model="password"
                )
                BaseButton(
                    type='submit'
                    slot="buttons"
                    label='Save',
                    size='MEDIUM',
                    :isWaiting='isSubmitting',
                    :isDisabled='$storyblok.isEditing'
                    class="pt-2 w-full"
                ) Submit
</template>

<script>
import formMixin from '@/components/form/mixin'
import BaseButton from '@/components/baseButton'
export default {
    name: 'StoryblokLogin',
    components: { BaseButton },
    mixins: [formMixin],
    data() {
        return {
            password: null,
            isSubmitting: false,
        }
    },
    methods: {
        async login() {
            // Double click protection
            if (this.isSubmitting) return
            this.isSubmitting = true
            await this.$store.dispatch('content/initContentData', {
                route: this.$route,
                password: this.password,
            })

            // If this component still renders after the above, the password was not correct
            if (this.$refs?.loginForm)
                this.$refs.loginForm.addError('accessCode', 'The code provided is incorrect')
            this.isSubmitting = false
        },
    },
}
</script>
